import * as dateFns from 'date-fns';

const URL_DATE_REGEX = /\b\d{4}-\d{2}-\d{2}\b/;

/**
 * The calendar day the staff member is looking at — the day every
 * configuration refetch after a timeslot write must target.
 *
 * Both screens that edit timeslots carry the day in the URL
 * (`/configuration/YYYY-MM-DD`, `/day/YYYY-MM-DD`), so that wins. Without
 * one (the `/` index day view) we fall back to `reservationReducer.currentDate`,
 * which `Schedule` keeps in sync on both screens via `changeDate`.
 * `reservationReducer.configurationDate` is deliberately NOT consulted: nothing
 * dispatches `changeConfigurationDate`, so it is always "today".
 *
 * Returns a Date at the start of that day.
 */
export const getViewedCalendarDate = (getState, href = window.location.href) => {
  const match = typeof href === 'string' ? href.match(URL_DATE_REGEX) : null;
  if (match) {
    const parsed = dateFns.parse(match[0], 'yyyy-MM-dd', new Date());
    if (dateFns.isValid(parsed)) {
      return dateFns.startOfDay(parsed);
    }
  }
  const currentDate = getState?.()?.reservationReducer?.currentDate;
  const fallback = currentDate ? new Date(currentDate) : new Date();
  return dateFns.startOfDay(dateFns.isValid(fallback) ? fallback : new Date());
};
